import { useMutation } from '@apollo/client'

import {
  CreateOrderPriceModifier,
  CustomFeeInput,
  OrderDiscount,
} from '__generated__/atlas-types'
import { UpdateFinancialSummaryDocument } from '__generated__/atlas-types'

import { atlasClient } from 'graphql/client'
import { atlas } from 'graphql/tags'

atlas`#graphql
  mutation UpdateFinancialSummary(
    $updateOrderFinancials: UpdateOrdersConnection!, 
    ) {
    updateOrders(input: $updateOrderFinancials){
      updatedOrders { 
        edges {
          node {
            id
            financials {
                ...OrderFinancials
            }
          }
        }
      }
      errors {
        message
      }
    }
  }
`

type FinancialSummaryParams = {
  orderId: string
  discount?: OrderDiscount
  tax?: CreateOrderPriceModifier
  shippingPrice?: number
  customFees?: CustomFeeInput[]
}

export const useUpdateFinancialSummary = () => {
  const [mutate, { loading }] = useMutation(UpdateFinancialSummaryDocument, {
    client: atlasClient,
  })
  return {
    updateFinancialSummary: (
      financialsWidgetParams: FinancialSummaryParams,
    ) => {
      const { orderId, discount, tax, shippingPrice, customFees } =
        financialsWidgetParams
      return mutate({
        variables: {
          updateOrderFinancials: {
            orders: [
              {
                id: orderId,
                ...(tax !== undefined ? { tax } : {}),
                ...(discount !== undefined ? { discount } : {}),
                ...(shippingPrice !== undefined ? { shippingPrice } : {}),
                ...(customFees ? { customFees } : {}),
              },
            ],
          },
        },
      })
    },
    loading,
  }
}
